import { bootSyft } from "./core";

bootSyft();
